/**
 * @generated SignedSource<<2a84a172c071037921eccb7a168107b2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "whoamiNext",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "firstName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "endpointComponentsWhoamiNextQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "endpointComponentsWhoamiNextQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5091334152297dde1a7908c57d2d7b84",
    "id": null,
    "metadata": {},
    "name": "endpointComponentsWhoamiNextQuery",
    "operationKind": "query",
    "text": "query endpointComponentsWhoamiNextQuery {\n  whoamiNext {\n    id\n    username\n    email\n    firstName\n  }\n}\n"
  }
};
})();

node.hash = "27425a6929eec69442991fc8eca376b7";

module.exports = node;
